import api from './api'
import type { CompanyInfo, HeroSection, ClientLogo, AboutPage, CompanyValue, CompanyTimeline } from '@/types'

export const companyService = {
  // Company Info
  getCompanyInfo: async (): Promise<CompanyInfo> => {
    const response = await api.get('/company/active/')
    return response.data
  },

  // Hero Section
  getHeroSection: async (): Promise<HeroSection> => {
    const response = await api.get('/hero/active/')
    return response.data
  },

  // Client Logos
  getClientLogos: async (): Promise<ClientLogo[]> => {
    const response = await api.get('/clients/')
    return response.data.results || response.data
  },

  // About Page
  getAboutPage: async (): Promise<AboutPage> => {
    const response = await api.get('/about/active/')
    return response.data
  },

  // Company Values
  getCompanyValues: async (): Promise<CompanyValue[]> => {
    const response = await api.get('/values/')
    return response.data.results || response.data
  },

  // Company Timeline
  getCompanyTimeline: async (): Promise<CompanyTimeline[]> => {
    const response = await api.get('/timeline/')
    return response.data.results || response.data
  },
}
